<template>
	<div class="pui-form">
		<anchorageoperations-modals :modelName="modelName"></anchorageoperations-modals>
		<!-- <pui-form-header v-if="modelLoaded" :showHeader="!isCreatingElement">
			<anchorageoperations-form-header :modelPk="modelPk"></anchorageoperations-form-header>
		</pui-form-header> -->
		<v-form class="mb-4 pb-4" ref="form" v-model="valid" lazy-validation v-if="modelLoaded">
			<v-row class="pui-form-layout">


				<!-- GENERAL INFORMATION -->
				<v-col cols="12">
					<pui-field-set :title="$t('anchorageoperations.generalinfo')">

						<v-row dense>
							<v-col cols="3">
								<pui-text-field v-model="model.statuscode" :label="$t('anchorageoperations.statuscode')"
									disabled toplabel />
							</v-col>

							<v-col cols="3">
								<pui-date-field v-model="model.arrivalrequestdate"
									:label="$t('anchorageoperations.arrivalrequestdate')" disabled toplabel time />
							</v-col>
							<v-col cols="3">
								<pui-date-field v-model="model.departurerequestdate"
									:label="$t('anchorageoperations.departurerequestdate')" disabled toplabel time />
							</v-col>
						</v-row>
					</pui-field-set>
				</v-col>
				<!-- COLUMNA IZQUIERDA -->
				<!-- ARRIVAL -->
				<v-col cols="6">
				<pui-field-set :title="$t('anchorageoperations.arrival')">
						<v-row dense>
							<v-col cols="6">
								<pui-text-field v-model="model.arrivalhmstatus"
									:label="$t('anchorageoperations.arrivalhmstatus')" disabled toplabel />
							</v-col>

							<v-col cols="6">
								<pui-date-field v-model="model.arrivalhmdate"
									:label="$t('anchorageoperations.arrivalhmdate')" disabled toplabel time />
							</v-col>


						</v-row>

						<v-row dense>

							<v-col cols="6">
								<pui-text-field v-model="model.arrivalcuofstatus"
									:label="$t('anchorageoperations.arrivalcuofstatus')" disabled toplabel />
							</v-col>
							<v-col cols="6">
								<pui-date-field v-model="model.arrivalcuofdate"
									:label="$t('anchorageoperations.arrivalcuofdate')" disabled toplabel time />
							</v-col>

						</v-row>

						<v-row dense>
							<v-col cols="6">
								<pui-text-field v-model="model.arrivalppstatus"
									:label="$t('anchorageoperations.arrivalppstatus')" disabled toplabel />
							</v-col>
							<v-col cols="6">
								<pui-date-field v-model="model.arrivalppdate"
									:label="$t('anchorageoperations.arrivalppdate')" disabled toplabel time />
							</v-col>
						</v-row>
						<v-row dense>
							<v-col cols="6">
								<pui-date-field v-model="model.arrivalapprovaldate"
									:label="$t('anchorageoperations.arrivalapprovaldate')" disabled toplabel time />
							</v-col>

							<v-col cols="12">
								<pui-text-area v-model="model.arrivalobservations"
									:label="$t('anchorageoperations.arrivalobservations')" disabled toplabel />
							</v-col>
						</v-row>
					</pui-field-set>
				</v-col>


				<!-- COLUMNA DERECHA -->
				<!-- DEPARTURE -->
				<v-col cols="6">

					<pui-field-set :title="$t('anchorageoperations.departure')">
						<v-row dense>
							<v-col cols="6">
							<pui-text-field v-model="model.departurehmstatus"
									:label="$t('anchorageoperations.departurehmstatus')" disabled toplabel />
							</v-col>

							<v-col cols="6">
								<pui-date-field v-model="model.departurehmdate"
									:label="$t('anchorageoperations.departurehmdate')" disabled toplabel time />
							</v-col>

						</v-row>

						<v-row dense>

							<v-col cols="6">
								<pui-text-field v-model="model.departurecuofstatus"
									:label="$t('anchorageoperations.departurecuofstatus')" disabled toplabel />
							</v-col>
							<v-col cols="6">
								<pui-date-field v-model="model.departurecuofdate"
									:label="$t('anchorageoperations.departurecuofdate')" disabled toplabel time />
							</v-col>


						</v-row>
						<v-row dense>
							<v-col cols="6">
								<pui-text-field v-model="model.departureppstatus"
									:label="$t('anchorageoperations.departureppstatus')" disabled toplabel />
							</v-col>
							<v-col cols="6">
								<pui-date-field v-model="model.departureppdate"
									:label="$t('anchorageoperations.departureppdate')" disabled toplabel time />
							</v-col>
						</v-row>

						<v-row dense>
							<v-col cols="6">
								<pui-date-field v-model="model.departureapprovaldate"
									:label="$t('anchorageoperations.departureapprovaldate')" disabled toplabel time />
							</v-col>

							<v-col cols="12">
								<pui-text-area v-model="model.departureobservations"
									:label="$t('anchorageoperations.departureobservations')" disabled toplabel />
							</v-col>
						</v-row>
					</pui-field-set>
				</v-col>


			</v-row>

			<pui-form-footer v-if="!isModalDialog">
				<pui-form-footer-btns :formDisabled="true" :saveDisabled="true" :back="back" />
			</pui-form-footer>
		</v-form>

		<pui-form-loading v-else></pui-form-loading>
	</div>
</template>

<script>
import PuiFormMethodsMixin from 'pui9-mixins/PuiFormMethodsMixin';
import anchorageoperationsActions from './AnchorageoperationsActions';
import anchorageoperationsModals from './AnchorageoperationsModals.vue';

export default {
	name: 'anchorageoperations-form',
	mixins: [PuiFormMethodsMixin],
	components: {
		'anchorageoperations-modals': anchorageoperationsModals
	},
	data() {
		return {
			modelName: 'anchorageoperations',
			actions: anchorageoperationsActions.formActions
		};
	},
	methods: {
		afterGetData() {
			if (this.$router.currentRoute.path.startsWith('/portcalls/')) {
				localStorage.setItem('tabFromAction', 'anchorageoperations');
			}
		}
	},
	computed: {},
	created() { }
};
</script>
